<template>
  <el-checkbox
    v-model="value"
    v-bind="trimAttrs($attrs)"
    :class="[
      'checkbox-' + checkboxSize,
      {'full-width': isFullWidth}
    ]"
  >
    <slot />
  </el-checkbox>
</template>

<script>
import { Checkbox } from 'element-ui';
export default {
  name: 'JskCheckbox',
  components: {
    ElCheckbox: Checkbox
  },
  inheritAttrs: false,
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: Boolean,
    checkboxSize: {
      type: String,
      default: 'mini'
    },
    isFullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      value: false
    };
  },
  watch: {
    value: function() {
      this.$emit('change', this.value);
      this.$nextTick(() => {
        if (this.value !== this.vModel) {
          this.value = this.vModel;
        }
      });
    },
    vModel: function() {
      this.value = this.vModel;
    }
  },
  created: function() {
    this.value = this.vModel;
  },
  methods: {
    trimAttrs: function(attrs) {
      Object.keys(attrs).forEach((key) => {
        let prefixes = ['is-', 'has-', 'checkbox-'];
        prefixes.forEach((prefix) => {
          if (key.substr(0, prefix.length) === prefix) {
            attrs[key.substr(prefix.length)] = attrs[key];
          }
        })
      })
      return attrs;
    }
  }
}
</script>

<style lang="scss" src="../../theme/checkbox.scss"></style>
